import { render, staticRenderFns } from "./LoadingBanner.vue?vue&type=template&id=b2f0fe00&scoped=true&lang=pug"
import script from "./LoadingBanner.vue?vue&type=script&lang=js"
export * from "./LoadingBanner.vue?vue&type=script&lang=js"
import style0 from "./LoadingBanner.vue?vue&type=style&index=0&id=b2f0fe00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f0fe00",
  null
  
)

export default component.exports